/* eslint-disable react/no-unescaped-entities */
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import React, { useEffect, useState } from "react";
import Markdown from "markdown-to-jsx";
import useMediaQuery from "@mui/material/useMediaQuery";
import { getCookiesInfo } from "./requestCall";
const cookiesPolicyWrapper = css`
  width: 100%;
  background: #121212;
  color: white;
`;
const cookiesPolicy = (matches) => css`
  padding: 20px 0;
  width: ${matches ? "calc(100% - 40px)" : "50%"};
  margin: 0 ${matches ? "20px" : "auto"};
  .title {
    font-size: 28px;
    font-weight: bold;
  }
  .cookie-policy-item {
    display: flex;
    flex-direction: column;
    line-height: 30px;
    margin: 30px 0;
    ul {
      margin: 0;
    }
    span:nth-of-type(1) {
      font-weight: bold;
    }
  }
  .cookie-policy-item:nth-of-type(1) {
    margin-top: 0;
  }
  .cookie-policy-item:nth-last-of-type(1) {
    margin-bottom: 0;
  }
  img {
    width: 100%;
  }
`;
const descriptionWrapper = css`
  font-size: 14px;
  line-height: 35px;
`;
const CookiesPolicy = () => {
  window.scrollTo(0, 0);
  const matches = useMediaQuery("(max-width: 415px)");
  const [cookieInfo, setCookieInfo] = useState();
  useEffect(() => {
    getCookiesInfo().then((res) => {
      document.title = res?.data?.data?.attributes?.title;
      setCookieInfo(res?.data?.data?.attributes);
    });
  }, []);
  return (
    <div css={cookiesPolicyWrapper}>
      <div css={() => cookiesPolicy(matches)}>
        <div className="title">{cookieInfo?.title}</div>
        <Markdown css={descriptionWrapper}>
          {(process.env.REACT_APP_BASEURL.includes("localhost")
            ? cookieInfo?.description?.replaceAll(
                "/uploads/",
                `${process.env.REACT_APP_BASEURL}/uploads/`
              )
            : cookieInfo?.description) || ""}
        </Markdown>
      </div>
    </div>
  );
};

export default CookiesPolicy;
